
  import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
  @Component({
    components: {

    }
  })
  export default class HeadlinesCard extends Vue {

  }
  